const React = require('react');
const PropTypes = require('prop-types');
const SpringClickGroup = require('./spring-click-group.react');
const RenderingUtils = require('../utils/rendering');
const createReactClass = require('create-react-class');

function strictEquals(value1, value2) {
  return value1 === value2;
}

const includesWithPredicate = (predicate) => {
  return (values, item) => values.some(i => predicate(i, item));
};

const Checkbox = createReactClass({
  propTypes: {
    // not available via context
    value: PropTypes.any,
    id: PropTypes.string,
    checked: PropTypes.bool,

    // also available via context
    onChange: PropTypes.func,
    name: PropTypes.string,
  },

  // note that Checkbox cannot take advantage of
  // PureRenderMixin yet because context is not well supported with it.
  // see: https://github.com/facebook/react/issues/2517
  contextTypes: {
    checkboxGroup: PropTypes.shape({
      onChange: PropTypes.func,
      selectedValues: PropTypes.arrayOf(PropTypes.any).isRequired,
      valueEqualityCheck: PropTypes.func,
      name: PropTypes.string,
    }),
  },

  UNSAFE_componentWillMount() {
    this.backupId = RenderingUtils.uniqueId('vogue-checkbox-button');
  },

  _onChange(...args) {
    const { props: { value, onChange: propsOnChange }, context } = this;
    const contextOnChange = context.checkboxGroup ? context.checkboxGroup.onChange : undefined;

    if (typeof contextOnChange === 'function') {
      contextOnChange(value, ...args);
    }

    if (typeof propsOnChange === 'function') {
      propsOnChange(value, ...args);
    }
  },

  render() {
    const { props, context } = this;
    const contextSelectedValues = context.checkboxGroup ? context.checkboxGroup.selectedValues : undefined;
    const valueIncludesCheck = includesWithPredicate(
      (context.checkboxGroup && context.checkboxGroup.valueEqualityCheck) || strictEquals
    );

    const {
      value,
      name = (context.checkboxGroup ? context.checkboxGroup.name : undefined),
      checked = valueIncludesCheck(contextSelectedValues, value),
      id = this.backupId,
      ...passedProps // i.e. `disabled`
    } = props;

    const propsForInput = {
      ...passedProps,
      onChange: this._onChange,
      value,
      name,
      checked,
    };

    return (
      <span className="Checkbox">
        <input id={ id } className="Checkbox-input" type="checkbox" { ...propsForInput } />
        <SpringClickGroup.Item>
          <label htmlFor={ id } className="Checkbox-button">
            <svg className="Checkbox-svg" viewBox="0 0 11 8" width="8px" height="8px">
              <path
                transform="translate(-6, -8)" fill="none"
                stroke="#FCFCFC" strokeWidth="1"
                strokeLinecap="round" strokeLinejoin="round"
                d="M17 8.5 9.5 15.5 7 13"
              />
            </svg>
          </label>
        </SpringClickGroup.Item>
      </span>
    );
  },
});

module.exports = Checkbox;
